import type { CalendarLeanEvent } from '../types';

/**
 * Synthetic ids minted by `getFilteredCampaigns` for drip steps that have no
 * campaign document of their own: `dripId:step:N` and `dripId:occ:<ts>:step:N`.
 *
 * Dragging one can only ever fail — `onCampaignEventDropThunk` looks the id up
 * as a campaign document and returns `not_found` — so the grid refuses the drag
 * up front instead of surfacing a warning dialog after the drop.
 */
export function isProjectedDripStep(id: string | undefined | null): boolean {
    return typeof id === 'string' && /:step:\d+$/.test(id);
}

/**
 * Identity of ONE occurrence.
 *
 * A recurring message expands into N events that all carry the parent
 * document's `_id` (`getRecurringMessages` pushes `{ ...m, dueDate }`), so `_id`
 * alone is not an identity: it has to be paired with the occurrence's own due
 * date. Used for React keys, the drag subject, day-panel rows and open-menu
 * state — anywhere two chips could otherwise be mistaken for each other.
 */
export function occurrenceKey(event: CalendarLeanEvent): string {
    const at = new Date(event.dueDate).getTime();
    return `${event.isCampaign ? 'c' : 'm'}:${event._id}@${at}`;
}
